export default __webpack_public_path__ + "static/media/1_0070.c35f5c80.webp";